
module.exports = function EmailDispatch ($host, config) {








};

